// @mui
import { Stack, Box } from '@mui/material';
// config
import { NAV } from '../../../config-global';
// utils
import { hideScrollbarX } from '../../../utils/cssStyles';
// components
import Logo from '../../../components/logo';
import { NavSectionMini } from '../../../components/nav-section';
//
import navConfig from './config-navigation';
import NavToggleButton from './NavToggleButton';
import { useEffect, useState } from 'react';

// ----------------------------------------------------------------------

export default function NavMini() {
  const [navList] = useState<any>([...navConfig])
  const [navConfig1,setNavConfig] = useState<any>([])
  useEffect(()=>{
    function deepClone(obj:any) {
      if(typeof obj !=="object" || obj == null){
          return obj 
      }
      let res 
      if(obj instanceof Array){
          res = []
      }else{
          res = {}
      }

      for( var key in obj){
          if(obj.hasOwnProperty(key)){
            //@ts-ignore
              res[key] = deepClone(obj[key])
          }
      }
      return res
  }
    var arr: any = localStorage.getItem('menu')
    var arr1:any =deepClone(navList)
    console.log(arr1)
    if (arr) {
      var arr2: any = []
      arr = JSON.parse(arr)
      arr.forEach((v: any) => {
        v.sub_modules.forEach((value: any) => {
          arr2.push(value.name)
        })
        arr1[0].items.forEach((val: any) => {
          if (v.name === val.title || val.title=="首页") {
            val.stu = true
          }
        })
      })
      arr1[0].items.forEach((val: any) => {
        if (val.stu&&val.title!="首页") {
          val.children = val.children.filter((value: any, idx: number) => {
            return arr2.indexOf(value.title) != -1
          })
        }
      })
      arr1[0].items = arr1[0].items.filter((v: any) => v.stu === true)
      console.log('navConfig123',arr1)
      setNavConfig(arr1)
    }else{
      console.log('navConfig',navConfig)
      setNavConfig(navConfig)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini data={navConfig1} />
      </Stack>
    </Box>
  );
}
